import React, { createContext, useContext, useMemo } from 'react';
import type { BusinessLocation } from 'src/api/types/business-types';
import { useAppAuth } from 'src/context/use-app-auth';

interface BillingContextValue {
  locations: BusinessLocation[];
  hasLocations: boolean;
}

const BillingContext = createContext<BillingContextValue | undefined>(
  undefined,
);

const BillingProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const { user } = useAppAuth();
  const locations = useMemo(() => user?.locations ?? [], [user?.locations]);

  const value = useMemo(
    () => ({
      locations,
      hasLocations: locations.length > 0,
    }),
    [locations],
  );

  return (
    <BillingContext.Provider value={value}>{children}</BillingContext.Provider>
  );
};

const useBilling = (): BillingContextValue => {
  const ctx = useContext(BillingContext);
  if (!ctx) {
    throw new Error('useBilling must be used within BillingProvider');
  }
  return ctx;
};

export { BillingProvider, useBilling };
